'use client';

import React, { useState } from 'react';
import {
  GetFishingWater_fishingWater_region,
  GetRegion_entry_country,
  GetRegionTopWaters_entry_topFishingWaters_edges_node,
  GetSpeciesAreaRecordsList_species_edges_node,
} from '../../../../interfaces/graphql';
import { useAnalytics } from '../../../../contexts/AnalyticsContext/AnalyticsContext';
import { trackEvent } from '../../../../helpers/analytics/trackEvent';
import { AppDownloadModal } from '../../../../components/AppDownloadModal/AppDownloadModal';
import { getFAQData } from './helpers/getFAQData';
import { FAQ } from '../../../../components/FAQ/FAQ';
import { TypeFaqListWithoutUnresolvableLinksResponse } from '../../../../interfaces/contentful';
import { getFAQDataFromContentful } from '../../../../components/FAQ/helpers/getFAQDataFromContentful';
import { SUB_LINK_IDS } from '../../helpers/regionHelpers';

interface IProps {
  className?: string;
  country: GetRegion_entry_country | null;
  customFaqList?: TypeFaqListWithoutUnresolvableLinksResponse;
  region: GetFishingWater_fishingWater_region | null;
  topSpecies?: GetSpeciesAreaRecordsList_species_edges_node[];
  topFishingWaters?: GetRegionTopWaters_entry_topFishingWaters_edges_node[];
  hasRegulations?: boolean;
}

export const FAQSection = ({
  className,
  country,
  customFaqList,
  region,
  topFishingWaters,
  topSpecies,
  hasRegulations,
}: IProps) => {
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);
  const { currentPage } = useAnalytics();

  const customTitle = customFaqList?.fields.title;
  const customFaqs = customFaqList?.fields.faqs;

  const customFaqData = customFaqs ? getFAQDataFromContentful({ faqs: customFaqs }) : [];

  const handleCTAClick = (): void => {
    void trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: 'FAQSection',
        source_id: region?.id ?? undefined,
        type: 'downloadModal',
        page: currentPage,
      },
    });
    setIsAppDownloadModalOpen(true);
  };

  const faqData = getFAQData({
    country,
    handleCTAClick,
    region,
    topSpecies,
    topFishingWaters,
    hasRegulations,
  });

  return (
    <FAQ
      className={className}
      faqData={[...faqData, ...customFaqData]}
      headingVariant="sm"
      showFAQMetaData
      id={SUB_LINK_IDS.FAQ}
      title={customTitle ?? `FAQ about ${region?.name} fishing`}
    >
      <AppDownloadModal
        appDownloadSourceId={region?.id ?? undefined}
        appDownloadSource="FAQSection"
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </FAQ>
  );
};
